<template>
  <v-dialog v-model="dialogVisible" width="330px">
    <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
      <v-avatar class="color-delete my-4" size="62">
        <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
      </v-avatar>
      <div class="text-center text-h6 align-center justify-center font-weight-medium">
        Confirm Deletion
      </div>
      <v-card-text class="align-center justify-center mt-2">
        Are you sure want to delete keyword?
      </v-card-text>
      <v-divider class="mt-4" style=""></v-divider>
      <v-card-actions class="align-center justify-center">
        <v-btn rounded class="my-3 btn-info" width="90px" dark @click="$emit('confirm')">
          OK
        </v-btn>
        <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    }
  }
}
</script>
